import theme from '../theme'
import { makeStyles } from '@material-ui/core'

const styleOverride = makeStyles({
  /* Styles applied to the root element. */
  root: {
    fontFamily: theme.typography.fontFamily,
    '& .MuiBadge-colorPrimary': {
      color: '#FFF!important',
      backgroundColor: '#6A148E!important'
    }
  },
})
export default styleOverride
